import { useDebounce } from "@website/hooks/debounce";
import { useDomFlightAirportsService } from "@website/ticket-ui/common/services/dom-flight-airport-service";
import {
  AirportsItemType,
  FormattedCity
} from "@website/ticket-ui/common/types";
import { useDomFlightSearchSuggestionsService } from "@website/ticket-ui/dom-flight-search-panel-old/services";
import { createOriginDestinationInputText } from "@website/ticket-ui/dom-flight-search-panel-old/utils/createSubtitle";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useOrigin = (origin: FormattedCity) => {
  const [originQuery, setOriginQuery] = useState<string>("");
  const [selectedOriginItem, setSelectedOriginItem] =
    useState<FormattedCity | null>(null);
  const query = useDebounce(originQuery, 250);

  const { data: suggestions } = useDomFlightSearchSuggestionsService();

  const { isLoading, data } = useDomFlightAirportsService(query);

  const onChangeOriginQuery = useCallback((value: string) => {
    setOriginQuery(value);
  }, []);

  useEffect(() => {
    //TODO set and get origin from store
    if (origin) {
      setSelectedOriginItem(origin);
    }
  }, [origin]);

  const originList = useMemo(
    () => (originQuery.length > 1 ? data || [] : suggestions || []),
    [data, suggestions, originQuery]
  );

  const selectedOriginText = useMemo(
    () => createOriginDestinationInputText(selectedOriginItem),
    [selectedOriginItem]
  );

  const onSelectOrigin = useCallback(
    (id: string) => {
      let originItem;
      originItem =
        originList.find(
          (origin: AirportsItemType) =>
            `${origin.iataCode}-${origin.cityName}` === `${id}`
        ) || null;
      if (!originItem) {
        for (const city of originList) {
          for (const airport of city.airports) {
            if (
              `${airport.iataCode}-${airport.name}-${city.cityName}` === `${id}`
            ) {
              originItem = {
                airportName: airport.name,
                airportFaName: airport.faName,
                airportIataCode: airport.iataCode,
                ...city
              };
            }
          }
        }
      }

      setOriginQuery("");
      setSelectedOriginItem(originItem);
    },
    [originList]
  );

  const onChangeOrigin = useCallback((item: FormattedCity | null) => {
    setOriginQuery("");
    setSelectedOriginItem(item);
  }, []);

  return {
    selectedOriginItem,
    selectedOriginText,
    originQuery,
    onChangeOrigin,
    onSelectOrigin,
    onChangeOriginQuery,
    originList,
    originLoading: isLoading,
    originLabel: "مبدا",
    originIsLoading: isLoading,
    originData: data
  };
};
